AFRAME.registerSystem("freeze-menu", {
  init: function () {
    this.activeMenuId = null;
  },

  setActiveMenu: function (menuId) {
    this.activeMenuId = menuId;
  },

  clearActiveMenu: function () {
    this.activeMenuId = null;
  },

  getActiveMenu: function () {
    return this.activeMenuId;
  },

  isMenuActive: function () {
    return this.activeMenuId !== null;
  }
});
